import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/** Evento emitido cuando el asistente EJECUTA una acción (tras confirmar). Lo
 * escuchan las vistas que muestran datos que pudieron cambiar (p.ej. el tab de
 * tareas del proyecto) para refrescarse sin recargar la página. */
export interface AccionEjecutada {
  accion: string;
  proyectoId: number | null;
  resultado: { ok: boolean; mensaje: string; task_id?: number };
}

/**
 * Bus liviano entre la burbuja del asistente (componente global del layout) y
 * las páginas del CRM. La burbuja no conoce a las páginas: sólo publica que se
 * ejecutó una acción; cada vista interesada se suscribe y decide si recargar.
 */
@Injectable({ providedIn: 'root' })
export class AsistenteAccionesService {
  private readonly _ejecutada = new Subject<AccionEjecutada>();
  /** Se emite cada vez que una acción del asistente se ejecuta con éxito. */
  readonly ejecutada$: Observable<AccionEjecutada> = this._ejecutada.asObservable();

  emitir(evento: AccionEjecutada): void {
    this._ejecutada.next(evento);
  }
}
